import { createSelector } from '@reduxjs/toolkit';
import { HyperVDogfoodingProjectUri } from '../../../constants/add-ons';
import { getTokensFromDevBoxDataPlaneUri } from '../../../ids/dev-box';
import { createProjectDataPlaneUri } from '../../../ids/project';
import { areStringsEquivalent } from '../../../utilities/string';
import { getDevBoxes } from '../../selector/dev-box-selectors';

/**
 * Application state selectors
 */

// For now, get add ons only for those dev boxes that are in the dogfooding pool
export const getIdsForDevBoxesRequiringDevBoxAddOns = createSelector([getDevBoxes], (devBoxes) =>
    devBoxes
        .filter((devBox) => {
            const { devCenter, projectName } = getTokensFromDevBoxDataPlaneUri(devBox.uri);
            const projectUri = createProjectDataPlaneUri({ devCenter, projectName });
            return areStringsEquivalent(projectUri, HyperVDogfoodingProjectUri, true);
        })
        .map((devBox) => devBox.uri)
);
